<template>
  <magic-markdown
    :source="schema.markdown"
    :anchorAttributes="anchorAttributes"
    :html="false"
    :image="true"
    :key="getFieldID(schema)"
    :id="getFieldID(schema)"
    :class="schema.fieldClasses" />
</template>

<script>
import { MixinDataToReactiveData } from 'assets/js/util';

import { abstractField } from 'components/Widgets/FormGenerator';
import MagicMarkdown from 'components/Widgets/MagicMarkdown';

export default {
  components: { MagicMarkdown },

  mixins: [abstractField],

  setup() {
    const afd = MixinDataToReactiveData(abstractField);
    return {
      ...afd,
    };
  },

  data() {
    return {
      anchorAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    };
  },
};
</script>

<style lang="scss">
.vue-form-generator .field-QLabel img {
  max-width: 90%;
}
</style>
